import api from "../api";

function toDateStr(d) {
  if (!d) return undefined;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function buildParams({ from, to, accounts = [], types = [] }) {
  const params = {};
  if (from) params.from = toDateStr(from);
  if (to)   params.to   = toDateStr(to);
  if (accounts.length) params["accounts[]"] = accounts;
  if (types.length)    params["types[]"]    = types;
  return params;
}

export const dashboardService = {

  summary: async (filters, { signal } = {}) => {
    const res = await api.get("/api/dashboard/summary/", {
      params: buildParams(filters),
      signal,
    });
    return res.data;
  },

  ranking: async (filters, { signal } = {}) => {
    const res = await api.get("/api/dashboard/ranking/", {
      params: buildParams(filters),
      signal,
    });
    return res.data;
  },

  leadsByStage: async (filters, { signal } = {}) => {
    const res = await api.get("/api/dashboard/leads-by-stage/", {
      params: buildParams(filters),
      signal,
    });
    return res.data;
  },

  messages: async (filters, { limit = 8, page = 1, signal } = {}) => {
    const res = await api.get("/api/dashboard/messages/", {
      params: { ...buildParams(filters), limit, page },
      signal,
    });
    return res.data;
  },
};
